import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="password"
export default class extends Controller {
  static targets = ["password", "button"];

  connect() {
    this.buttonTarget.textContent = "パスワードを表示状態にする";
  }

  toggle(event) {
    event.preventDefault();
    const isPasswordVisible = this.passwordTarget.type === "password";

    if (isPasswordVisible) {
      this.passwordTargets.forEach((e) => {
        e.type = "text";
      });
      this.buttonTargets.forEach((e) => {
        e.textContent = "パスワードを非表示状態にする";
        e.classList.add("is-show");
      });
    } else {
      this.passwordTargets.forEach((e) => {
        e.type = "password";
      });
      this.buttonTargets.forEach((e) => {
        e.textContent = "パスワードを表示状態にする";
        e.classList.remove("is-show");
      });
    }
  }
}
